import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const GlassTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  // 使用唯一 ID 避免多實例 SVG gradient 衝突
  const heartGradId = 'glass-tmpl-heart-grad';

  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(135deg, #0a1628 0%, #1e3a5f 30%, #2d5a7b 60%, #1e3a5f 100%)',
        overflow: 'hidden', fontFamily: 'Arial, sans-serif',
        position: 'relative', boxSizing: 'border-box'
      }}
    >
      <div style={{ position: 'absolute', top: '10%', left: '10%', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(100, 200, 255, 0.4) 0%, transparent 70%)', filter: 'blur(100px)' }} />
      <div style={{ position: 'absolute', bottom: '15%', right: '10%', width: '600px', height: '600px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(50, 150, 255, 0.3) 0%, transparent 70%)', filter: 'blur(120px)' }} />

      {/* 隱藏 SVG defs */}
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <linearGradient id={heartGradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#64c8ff" />
            <stop offset="100%" stopColor="#3296ff" />
          </linearGradient>
        </defs>
      </svg>

      <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: '100px 80px 80px 80px', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{ display: 'inline-block', padding: '30px', background: 'rgba(255, 255, 255, 0.12)', backdropFilter: 'blur(20px)', borderRadius: '50%', border: '2px solid rgba(255, 255, 255, 0.3)', boxShadow: '0 10px 40px rgba(100, 200, 255, 0.3)' }}>
            <svg width="160" height="160" viewBox="0 0 24 24" fill="none">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill={`url(#${heartGradId})`} />
            </svg>
          </div>
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          <div style={{ fontSize: '240px', fontWeight: '800', color: '#ffffff', lineHeight: '1', marginBottom: '30px', fontFamily: 'Arial, sans-serif', letterSpacing: '-5px', textShadow: '0 0 40px rgba(100, 200, 255, 0.8)' }}>{calculatedDays}</div>
          <div style={{ fontSize: '50px', fontWeight: '600', color: '#b3e5ff', marginBottom: '60px', textShadow: '0 0 20px rgba(100, 200, 255, 0.6)' }}>{language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}</div>
          {detailedTime && (<div style={{ fontSize: '38px', color: '#ffffff', fontWeight: '500', marginBottom: '40px', padding: '20px 50px', background: 'rgba(255, 255, 255, 0.12)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.25)', borderRadius: '60px', display: 'inline-block', boxShadow: '0 10px 40px rgba(100, 200, 255, 0.25)' }}>{formatDetailedTime(detailedTime, language)}</div>)}
          {quote && (<div style={{ fontSize: '32px', color: '#d0efff', fontStyle: 'italic', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto', textShadow: '0 2px 10px rgba(0, 0, 0, 0.7)' }}>"{quote}"</div>)}
        </div>

        <div style={{ textAlign: 'center', background: 'rgba(255, 255, 255, 0.08)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.2)', borderRadius: '30px', padding: '30px 40px', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)' }}>
          {anniversaryDate && (<div style={{ fontSize: '30px', color: '#b3e5ff', marginBottom: '15px' }}>{formatDate(anniversaryDate, language)}</div>)}
          <div style={{ fontSize: '36px', fontWeight: '700', color: '#64c8ff', textTransform: 'uppercase', letterSpacing: '3px', marginBottom: '10px', textShadow: '0 0 20px rgba(100, 200, 255, 0.6)' }}>{getBrandingText(anniversaryType, language)}</div>
          <div style={{ fontSize: '26px', color: '#b3e5ff', opacity: 0.9 }}>lovedays.homy.hk</div>
        </div>
      </div>
    </div>
  );
};

export default GlassTemplate;